import { emailRE } from './regular-expressions'

export const emailListIsValid = (emailList: string): boolean => {
  if (!emailList.includes(',')) return emailRE.test(emailList)
  for (const email of emailList.split(',')) {
    if (!emailRE.test(email)) return false
  }
  return true
}
